import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
// import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBCol } from "mdbreact";
// import content from "../Helpers/home-content-data"

import { Grid, Image } from "semantic-ui-react";
import capacityImage from "../images/capacitybuilding.png";
import irrigationImage from "../images/irrigationmanagement.png";
import etImage from "../images/evapotranspiration.png";
import vicImage from "../images/hydrologicalmodelling.png";
import hdImage from "../images/hydrologicaldrought.png";
import snowImage from "../images/snowmeltrunoff.png";
import glofImage from "../images/glaciallakes.png";
import floodImage from "../images/flood.png";
import humid from "../images/humid.png"

import { Link } from "react-router-dom";
class HomeCardDeck extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {

    return (
      <div className="container">
      
        <Grid
          columns={4}
          mobile={16}
          tablet={8}
          computer={4}
          divided
          style={{ marginLeft: "10px" }}
        >
          <Grid.Row>
            {" "}
            <Grid.Column mobile={16} tablet={8} computer={4}>
              <Link to="/webgis-flood/map">
                <Image src={floodImage} title="Spatial Flood Warning System (Experimental)" />
                {/* <MDBCardBody>
                            <MDBCardTitle><h5>Real-time Operational Spatial Flood Early Warning System Development</h5></MDBCardTitle>
                            
                            <MDBCardText>
                              
                            </MDBCardText>
                            {/* <div style={{align:"right"}}><h6 >More</h6></div> */}
              </Link>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={4}>
              <Link to="/webgis-et/map">
                <Image src={etImage} title="Regional Evaporative Flux Monitoring System" />
                {/* <MDBCardBody>
                            <MDBCardTitle><h5>Development of Satellite-based Regional Evaporative Flux Monitoring System for India</h5></MDBCardTitle>
                            
                            <MDBCardText>
                              
                            </MDBCardText>
                          
                        </MDBCardBody> */}
              </Link>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={4}>
              <Link to="/webgis-glacials/map">
                <Image src={glofImage} title="Glacial Lake Outburst Flood (GLOF) Risk Assessment of Glacial Lakes in the Himalayan Region of Indian River Basins" />
                {/* <MDBCardBody>
                            <MDBCardTitle><h5>Glacial Lake Outburst Flood (GLOF) Risk Assessment</h5></MDBCardTitle>
                            
                            <MDBCardText>
                              
                            </MDBCardText>
                          
                        </MDBCardBody> */}
              </Link>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={4}>
              <Link to="/webgis-snow/map">
                <Image src={snowImage} title="Himalayan Snow Cover Information System" />
                {/* <MDBCardBody>
                            <MDBCardTitle><h5>Development of spatial snowmelt runoff product in the Indian Himalayas</h5></MDBCardTitle>
                            
                            <MDBCardText>
                              
                            </MDBCardText>
                          
                        </MDBCardBody> */}
              </Link>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid
          columns={4}
          mobile={16}
          tablet={8}
          computer={4}
          divided
          style={{ marginLeft: "15px" }}
        >
          <Grid.Row stretched>
            {" "}
            <Grid.Column mobile={16} tablet={8} computer={4}>
              <Link to="/webgis-vic/map">
                <Image src={vicImage} title="Hydrological Modelling System" />
                {/* <MDBCardBody>
                            <MDBCardTitle><h5>Operational National Hydrological Modelling System for the entire Country</h5></MDBCardTitle>
                            
                            <MDBCardText>
                              
                            </MDBCardText>
                          
                        </MDBCardBody> */}
              </Link>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={4}>
              <Link to="/webgis-irrigation/map">
                <Image src={irrigationImage} fluid title="Satellite data based inputs for Irrigation Scheduling" />
                {/* <MDBCardBody>
                            <MDBCardTitle><h5>Satellite data based inputs for Irrigation Scheduling for a selected Irrigation Project command area</h5></MDBCardTitle>
                            
                            <MDBCardText>
                              
                            </MDBCardText>
                          
                        </MDBCardBody> */}
              </Link>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={4}>
              <Link to="/webgis-drought/map" title="Hydrological Drought">
                <Image src={hdImage} />
                {/* <MDBCardBody>
                            <MDBCardTitle><h5>Operational hydrological drought services using remote sensing data</h5></MDBCardTitle>
                            
                            <MDBCardText>
                              
                            </MDBCardText>
                          
                        </MDBCardBody> */}
              </Link>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={4}>
              <Link to="/trainingnew/courses" title="Capacity Building">
                <Image src={capacityImage} />
                {/* <MDBCardBody>
                            <MDBCardTitle><h5>Customized RS & GIS Training and Capacity Building</h5></MDBCardTitle>
                            
                            <MDBCardText>
                              
                            </MDBCardText>
                          
                        </MDBCardBody> */}
              </Link>
            </Grid.Column>
            
          </Grid.Row>

         
          <a href="https://bhuvan.nrsc.gov.in/humid"  target="_blank" style={{ left: "-25px",position:"relative",top:"15px" }}> 
         
          
<div style={{ width: '100%', height: '15vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
  <div style={{ padding: '10px 30px 30px 70px', maxWidth: '100%' }}>
    <img src={humid} alt="Humid" style={{maxWidth: '100%', height: 'auto' }} />
  </div>
</div>
          
          </a>
       
         
        
                
                 
        </Grid>
      </div>
    );
  }
}

export default HomeCardDeck;